import React, { useState } from "react";
import { IoFlaskOutline } from "react-icons/io5";
import { LiaPrescriptionSolid } from "react-icons/lia";
import PrescriptionList from "./PrescriptionList";
import LabList from "./LabList";
import { useHistory, useLocation } from "react-router-dom";
import { APP_ROUTES } from "../../../../../PageRouting/approutes";

function Index() {
  const [activeTab, setActiveTab] = useState("prescription");
  const history = useHistory();
  const handleTabSwitch = (type) => {
    setActiveTab(type);
  };
  const handleNavigation = () => {
    history.push(APP_ROUTES.RPMMEDICALRECORDS);
  };
  return (
    <div>
      <div className="bg-white rounded-lg p-3 h-fit flex flex-col justify-between border">
        <div className="flex justify-between items-center pb-2">
          <div className="text-black text-base font-sans font-bold">
            Medical Records
          </div>
          <div className="flex gap-3">
            <p
              className={`rounded-full w-7 h-7 flex items-center justify-center border cursor-pointer ${
                activeTab === "prescription"
                  ? "text-white bg-brand-primaryColor"
                  : ""
              }`}
              onClick={() => handleTabSwitch("prescription")}
            >
              <LiaPrescriptionSolid className="w-4 h-4" />
            </p>
            <p
              className={`rounded-full w-7 h-7 flex items-center justify-center border cursor-pointer ${
                activeTab === "lab" ? "text-white bg-brand-primaryColor" : ""
              }`}
              onClick={() => handleTabSwitch("lab")}
            >
              <IoFlaskOutline className="w-4 h-4" />
            </p>
          </div>
        </div>
        <div className="text-sm text-gray-500 border rounded-lg p-2 mt-3 h-28 overflow-y-scroll scrollHide">
          {activeTab === "prescription" && <PrescriptionList />}
          {activeTab === "lab" && <LabList />}
        </div>

        <div
          onClick={() => handleNavigation()}
          className="text-center mt-3 text-brand-primaryColor hover:underline cursor-pointer text-sm font-inter font-medium"
        >
          See All
        </div>
      </div>
    </div>
  );
}

export default Index;
